import Helpers from '../modules/Helpers'
import Reveal from '../modules/Reveal'


var StarReviewField = document.getElementsByClassName('StarReviewField')
var stars = document.getElementsByClassName('star')
var submit = document.getElementsByClassName('questionnaire__buttons-submit')

//set the review stars from db

for (var i = 0; i < stars.length; i++) {
    var starNum = stars[i].getAttribute('data-starNumber')
    if (starNum <= StarReviewField[0].value) {
        new Helpers(stars[i]).addClass('star--rated')
    }
}

new Helpers(stars).eventListener((e) => {
    new Helpers(stars).removeClass('star--rated')
    var StarClicked = e.target

    for (var i = 0; i < StarClicked.getAttribute('data-starNumber'); i++) {
        new Helpers(stars[i]).addClass('star--rated')
    }
    StarReviewField[0].value = StarClicked.getAttribute('data-starNumber')
})


var quest = { unAnsweredQuestions: 0, submitCount: 0 }
quest.validationMessage = document.getElementById('questionnaire__validation-message')

//Validate responses as essential fields on version 2:
if (quest.validationMessage !== null){
    var submitButton = document.getElementsByClassName('questionnaire__buttons-submit')
    var form = new Helpers(submitButton).getClosest('form')
    form.checkValidity = function () {
        return quest.checkOnComplete()
    }

    var answers = document.getElementsByTagName("input")
    new Helpers(answers).eventListener((e) => {
        quest.trackUnanswered()
    })
}


quest.checkOnComplete = function () {
    quest.submitCount++
    quest.trackUnanswered()
    return !(quest.unAnsweredQuestions > 0)
}

quest.trackUnanswered = function () {

    if (quest.validationMessage !== null) {
        quest.checkQuestions()
        if (quest.unAnsweredQuestions > 0) {
            quest.validationMessage.innerText = 'Please complete the ' + quest.unAnsweredQuestions.toString() + ' unanswered question' + (quest.unAnsweredQuestions > 1 ? 's' : '') + ' above before pressing submit.'
            if (quest.submitCount > 0) {
                new Helpers(quest.validationMessage).addClass('incomplete')
            }
        } else {
            quest.validationMessage.innerText = ''
        }
    }
}

quest.checkAQuestion = function (rdoGroupName, rdoLabelId) {

    rdoLabelId = (typeof rdoLabelId === 'undefined') ? rdoGroupName : rdoLabelId
    var rdoLabel = document.getElementById(rdoLabelId)

    if (rdoLabel !== null) {
        try {
            if (quest.RDONull(rdoGroupName)) {
                quest.unAnsweredQuestions++
                if (quest.submitCount > 0) {
                    rdoLabel.classList.add('incomplete')
                }
            } else {
                rdoLabel.classList.remove('incomplete')
            }
        }
        catch (e) {
            console.log(e)
            rdoLabel.classList.remove('incomplete')
        }
    }
}

quest.checkQuestions = function () {
   quest.unAnsweredQuestions = 0
    quest.checkAQuestion('qstDescription')
    quest.checkAQuestion('qstBooking')
   quest.checkAQuestion('qstRD')
    quest.checkAQuestion('qstStaff')
    quest.checkAQuestion('nps','nps-label')
   quest.checkAQuestion('qstCleanliness')
   quest.checkAQuestion('qstLocation')
   quest.checkAQuestion('qstComfort')
   quest.checkAQuestion('qstDFE')
   quest.checkAQuestion('qstInventory')
   quest.checkAQuestion('qstValue')
   quest.checkAQuestion('qstExpectation')
    //quest.checkAQuestion('rdoReccommend', 'qstReccommend')

}


quest.RDONull = function (RDOGroupName) {
    var ctls = document.getElementById(RDOGroupName).getElementsByTagName("input")
    for (var i = 0; i < ctls.length; i++) {
        if (ctls[i].checked) {
            return false
        }
    }
    return true;
}